import { orderXClient } from '@/service/client'
import type { CoinMarketCalHistoryParams } from '@/service/coinmarketcal.types'
import { CoinMarketCalEventList, DataPayload } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchCoinMarketCalEvents(payload: CoinMarketCalHistoryParams) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { getCoinmarketcalEvents: payload },
      { headers: { 'X-Decode-Key': 'datapayload' } }
    )
    const eventList = data.coinmarketcalEventList
    if (!eventList) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch CoinMarketCal events',
      })
    }
    return eventList as CoinMarketCalEventList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
